/**
 * Scriptures for lesson high-priest-2 (shepherding). Text from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const highPriest2TrainingScripturesEn: Scripture[] = [
  {
    id: 'john-21-15-17',
    reference: 'John 21:15–17',
    text:
      'So when they had dined, Jesus saith to Simon Peter, Simon, son of Jonas, lovest thou me more than these? He saith unto him, Yea, Lord; thou knowest that I love thee. He saith unto him, Feed my lambs. He saith to him again the second time, Simon, son of Jonas, lovest thou me? He saith unto him, Yea, Lord; thou knowest that I love thee. He saith unto him, Feed my sheep. He saith unto him the third time, Simon, son of Jonas, lovest thou me? Peter was grieved because he said unto him the third time, Lovest thou me? And he said unto him, Lord, thou knowest all things; thou knowest that I love thee. Jesus saith unto him, Feed my sheep.',
    verses: [
      {
        verse: 15,
        text: 'So when they had dined, Jesus saith to Simon Peter, Simon, son of Jonas, lovest thou me more than these? He saith unto him, Yea, Lord; thou knowest that I love thee. He saith unto him, Feed my lambs.',
      },
      {
        verse: 16,
        text: 'He saith to him again the second time, Simon, son of Jonas, lovest thou me? He saith unto him, Yea, Lord; thou knowest that I love thee. He saith unto him, Feed my sheep.',
      },
      {
        verse: 17,
        text: 'He saith unto him the third time, Simon, son of Jonas, lovest thou me? Peter was grieved because he said unto him the third time, Lovest thou me? And he said unto him, Lord, thou knowest all things; thou knowest that I love thee. Jesus saith unto him, Feed my sheep.',
      },
    ],
    context: 'Jesus charges Peter to feed the flock as an expression of love.',
  },
  {
    id: 'ephesians-4-29',
    reference: 'Ephesians 4:29',
    text:
      'Let no corrupt communication proceed out of your mouth, but that which is good to the use of edifying, that it may minister grace unto the hearers.',
    verses: [
      {
        verse: 29,
        text: 'Let no corrupt communication proceed out of your mouth, but that which is good to the use of edifying, that it may minister grace unto the hearers.',
      },
    ],
    context: 'Speak to build up and to give grace to those who hear.',
  },
  {
    id: 'alma-7-11-12',
    reference: 'Alma 7:11–12',
    text:
      'And he shall go forth, suffering pains and afflictions and temptations of every kind; and this that the word might be fulfilled which saith he will take upon him the pains and the sicknesses of his people. And he will take upon him death, that he may loose the bands of death which bind his people; and he will take upon him their infirmities, that his bowels may be filled with mercy, according to the flesh, that he may know according to the flesh how to succor his people according to their infirmities.',
    verses: [
      {
        verse: 11,
        text: 'And he shall go forth, suffering pains and afflictions and temptations of every kind; and this that the word might be fulfilled which saith he will take upon him the pains and the sicknesses of his people.',
      },
      {
        verse: 12,
        text: 'And he will take upon him death, that he may loose the bands of death which bind his people; and he will take upon him their infirmities, that his bowels may be filled with mercy, according to the flesh, that he may know according to the flesh how to succor his people according to their infirmities.',
      },
    ],
    context: 'Christ takes upon him our afflictions to know how to succor us in our weakness.',
  },
];
